// @flow

import { ReduxAsyncAction } from '../support/utils';
import dash_api from '../support/dash_api';

const SNAP_ROUTE = '/v1/snap';

const GetAccounts = new ReduxAsyncAction('SNAP_GET_ACCOUNTS');
GetAccounts.registerRequest(() => {
  return dash_api.get(`${SNAP_ROUTE}/get-accounts`).then(({ data }) => {
    return { accounts: data };
  });
});

export const GET_ACCOUNTS = GetAccounts.constants;
export const getAccounts = GetAccounts.request;
